var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./index.module.css";
import { useEffect, useState } from "react";
import { topbarButtons } from "../config/topbar/Topbar";
import { EditorTitle } from "@/04-features/edit-title";
import { MarkdownEditor } from "@/04-features/edit-document";
import { EditorTopbar } from "@/04-features/editor-toolbar";
import { getDocument } from "@/06-shared/api";
import { useNotifyError } from "@/06-shared/lib/useNotifyError";
import { editorConfig } from "../lib/codemirror/config";
const Editor = ({ documentId, showTitle = true }) => {
    const [content, setContent] = useState("");
    const [editorState, setEditorState] = useState(null);
    const [editorView, setEditorView] = useState(null);
    const [isReadOnly, setReadOnly] = useState(false);
    const [title, setTitle] = useState("");
    const [isLoaded, setIsLoaded] = useState(false);
    const showError = useNotifyError();
    useEffect(() => {
        let isActive = true;
        const loadDocument = () => __awaiter(void 0, void 0, void 0, function* () {
            setIsLoaded(false);
            try {
                const document = yield getDocument({ docId: documentId });
                if (!isActive)
                    return;
                setContent(document.content);
                setTitle(document.title);
            }
            catch (error) {
                if (!isActive)
                    return;
                showError(error);
            }
            finally {
                if (!isActive)
                    return;
                setIsLoaded(true);
            }
        });
        loadDocument();
        return () => {
            isActive = false;
        };
    }, [documentId]);
    return (_jsxs("div", Object.assign({ className: styles.editorWrapper }, { children: [showTitle ?
                _jsx(EditorTitle, { documentId: documentId, title: title, onChange: setTitle, readOnly: isReadOnly, autoSaveEnabled: isLoaded }) : null, _jsx(EditorTopbar, { state: editorState, view: editorView, topbarButtons: topbarButtons, isReadOnly: isReadOnly, onToggleReadOnly: () => setReadOnly((value) => !value) }), _jsx(MarkdownEditor, { documentId: documentId, content: content, onChange: setContent, config: editorConfig, onCreateEditor: (view, state) => {
                    setEditorView(view);
                    setEditorState(state);
                }, onUpdate: (update) => {
                    if (update.docChanged || update.selectionSet) {
                        setEditorState(update.state);
                    }
                }, readOnly: isReadOnly, autoSaveEnabled: isLoaded })] })));
};
export default Editor;
